import { render } from "./serviceCard.vue?vue&type=template&id=2278ca7c"
import script from "./serviceCard.vue?vue&type=script&lang=js"
export * from "./serviceCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__